module.exports = __webpack_public_path__ + "static/media/doctor-07.cdcf3370.jpg";